<template>
  <div>
    <div class="goodsOne" v-for="(item, index) in tabledata" :key="item.id">
      <div class="smallimg">
        <img :src="getImageSrc(item.pic)" @click="handleImageClick(item)">
      </div>

      <!-- 使用 v-show 来控制大图的显示和隐藏 -->
      <div class="bigimg" v-if="showBigImg && currentItem === item" @click="handleBigImgClick">
        <div class="big">
          <img :src="getImageSrc(item.pic)">
        </div>
      </div>

      <b>{{ item.name }}</b>
      <i v-if="item.price && item.price > 0">{{ item.price }}灵石</i>
      <div class="chos" @click="handleGetgooid(item)" :class="{ 'selected': isSelected(item.gooid) }"></div>
    </div>
  </div>
</template>


<script>
// import fill from '../../../hand-api/uploads/';
export default {
  name: 'goodsListOne',
  props: ['tabledata', 'selectAllid'],
  data() {
    return {
      apip: 'https://www.handingszy.top/uploads/',
      selectedProducts: [],  // 存储选中的产品id
      showBigImg: false,     // 控制大图的显示与隐藏
      currentItem: null      // 当前显示的大图对应的item
    };
  },
  watch: {
    selectAllid(newVal) {
      this.selectedProducts = [...newVal];
    }
  },
  methods: {
    // 获取图片路径
    getImageSrc(pic) {
      if(pic && pic != null && pic != undefined) {
        // 使用模板字符串直接返回路径，适用于 URL
        return this.apip + pic;
      } else {
        // 异常捕捉，返回默认图片
        return this.apip + 'default.jpg';
      }
    },
    // getImageSrc(pic) {
    //   try { // 正确进入
    //     // 通过require.context来动态加载图片，确保路径正确
    //     return require(`../../../hand-api/uploads/${pic}`);
    //   } catch (error) { // 异常捕捉
    //     // 图片加载失败时返回默认图片
    //     // console.error(`Error loading image: ${pic}`, error);
    //     return require('../../../hand-api/uploads/default.jpg');
    //   }
    // },
    handleGetgooid(item) {
      if (item && item.gooid) {
        const index = this.selectedProducts.indexOf(item.gooid);
        if (index === -1) {
          this.selectedProducts.push(item.gooid);
        } else {
          this.selectedProducts.splice(index, 1);
        }
      }
      // 将选中的id返回到父组件
      this.$emit('update-selected', this.selectedProducts);
    },
    isSelected(id) {
      return this.selectedProducts.includes(id);
    },
    // 点击小图时，显示大图
    handleImageClick(item) {
      this.showBigImg = true;  // 显示大图
      this.currentItem = item;  // 设置当前显示的大图对应的item
    },
    // 点击大图时，隐藏大图
    handleBigImgClick() {
      this.showBigImg = false;  // 隐藏大图
      this.currentItem = null;  // 清空当前显示的大图
    },
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.goodsOne {
  width: 100%;
  height: 200rem;
  font-size: 60rem;
  background-color: rgb(206, 245, 149);
  border-bottom: 2rem solid gray;
  display: flex;
  align-items: center;

  .smallimg {
    width: 150rem;
    height: 150rem;
    margin-left: 25rem;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .bigimg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4);

    .big {
      position: relative;
      background-color: rgba(212, 212, 212, 0.4);
      margin: 10vh auto;
      border: 1px solid #888;
      border-radius: 20rem;
      width: 80vw;
      height: 80vh;
      z-index: 1001;
      overflow: auto;

      img {
        width: 100%;
      }
    }

    .big::-webkit-scrollbar {
      display: none;
      /* 默认情况下隐藏滚动条 */
    }
  }

  b {
    display: inline-block;
    width: 20vw;
    height: 150rem;
    line-height: 150rem;
    white-space: nowrap;
    text-align: center;
    overflow-x: auto;
    overflow-y: hidden;
  }

  b::-webkit-scrollbar {
    display: none;
  }

  i {
    display: inline-block;
    width: 20vw;
    text-align: center;
    // margin-left: 50rem;
  }

  .chos {
    width: 150rem;
    height: 150rem;
    border-radius: 100%;
    background-color: white;
    margin-left: auto;
  }

  .selected {
    background-color: rgb(3, 252, 3);
  }
}
</style>
